import { supabase } from '../lib/supabase';

export const testimonialService = {
  // Get all published testimonials (public)
  async getPublished(category = null) {
    try {
      let query = supabase?.from('testimonials')?.select('*')?.eq('is_published', true)?.order('date', { ascending: false });

      if (category && category !== 'all') {
        query = query?.eq('category', category);
      }

      const { data, error } = await query;
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get all testimonials (admin only)
  async getAll() {
    try {
      const { data, error } = await supabase?.from('testimonials')?.select('*')?.order('created_at', { ascending: false });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Create testimonial (admin only)
  async create(testimonialData) {
    try {
      const { data, error } = await supabase?.from('testimonials')?.insert({
          client_name: testimonialData?.clientName,
          client_role: testimonialData?.clientRole,
          location: testimonialData?.location,
          image: testimonialData?.image || null,
          rating: testimonialData?.rating,
          category: testimonialData?.category,
          problem: testimonialData?.problem,
          testimonial_text: testimonialData?.testimonialText,
          result: testimonialData?.result,
          date: testimonialData?.date,
          is_commercial: testimonialData?.isCommercial || false,
          is_featured: testimonialData?.isFeatured || false,
          is_published: testimonialData?.isPublished !== undefined ? testimonialData?.isPublished : true
        })?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Update testimonial (admin only)
  async update(testimonialId, updates) {
    try {
      const dbUpdates = {};
      if (updates?.clientName !== undefined) dbUpdates.client_name = updates?.clientName;
      if (updates?.clientRole !== undefined) dbUpdates.client_role = updates?.clientRole;
      if (updates?.location !== undefined) dbUpdates.location = updates?.location;
      if (updates?.image !== undefined) dbUpdates.image = updates?.image;
      if (updates?.rating !== undefined) dbUpdates.rating = updates?.rating;
      if (updates?.category !== undefined) dbUpdates.category = updates?.category;
      if (updates?.problem !== undefined) dbUpdates.problem = updates?.problem;
      if (updates?.testimonialText !== undefined) dbUpdates.testimonial_text = updates?.testimonialText;
      if (updates?.result !== undefined) dbUpdates.result = updates?.result;
      if (updates?.date !== undefined) dbUpdates.date = updates?.date;
      if (updates?.isCommercial !== undefined) dbUpdates.is_commercial = updates?.isCommercial;
      if (updates?.isFeatured !== undefined) dbUpdates.is_featured = updates?.isFeatured;
      if (updates?.isPublished !== undefined) dbUpdates.is_published = updates?.isPublished;

      const { data, error } = await supabase?.from('testimonials')?.update(dbUpdates)?.eq('id', testimonialId)?.select();

      if (error) throw error;
      return { data: data?.[0] ?? null, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Delete testimonial (admin only)
  async delete(testimonialId) {
    try {
      const { error } = await supabase?.from('testimonials')?.delete()?.eq('id', testimonialId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error };
    }
  }
};